<template>
	<!-- BLOCK FEATURES -->
	<section class="sec-features mb-3 mar-slider" id="sec-features">
		<!-- loading -->
		<div v-if="loading"></div>

		<div v-else class="container ">
			<div class="row position-relative" v-if="listNews && listNews.length>0">
				<div class="slider slider-features wrap-item owl-carousel" v-bind:class="{'owl-theme': checkPageHideHeader }"
					data-pagination="false" data-autoplay="true" data-navigation="true" data-itemscustom="[[0,1]]" id="slider">
					<!-- item -->
					<div  v-for="(item, index) in listNews" :key="index" class="item item-slider item-slider1" >
						<img :src="item.news_image_path" :alt="item.news_image_alt" />
						<!-- description -->
						<div class="description">
							<h3 v-if="item.news_link ===''" class="text-30 clo-white">{{ item.news_title }}</h3>
							<h3 v-else class="text-30 clo-white"><a :href="item.news_link" class="clo-white">{{ item.news_title }}</a></h3>
							<div class="mirror">
							<p class="font-weight-bold clo-white" v-if="item.news_subtitle !== ''">{{ item.news_subtitle }}</p>
							<span>{{ item.news_description }}</span>
							<a :href="item.news_link">
								<svg class="icon-right" aria-hidden="true" width="32" height="32" title="">
								<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-right"></use>
								</svg>
							</a>
							</div>
						</div>
					</div>

			
				</div>

				<!-- custom nav -->
				<div id="slider-features-nav" class="slider-features-nav">
					<a class="p_slider_features" href="javascript:;">
						<svg aria-hidden="true" width="14" height="28" title="">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#slider-nav-p"></use>
						</svg>
					</a>
					<a class="n_slider_features" href="javascript:;">
						<svg aria-hidden="true" width="14" height="28" title="">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#slider-nav-n"></use>
						</svg>
					</a>
				</div>
			</div>
		</div>
	</section>
</template>
<style>
.mirror{
  position: relative
}
.icon-right{
    position: absolute;
    right: 0px;
    bottom: 40px;
}
</style>
<script>
	// import
	// import $ from "jquery";
	// import data from "./data.json";
	import * as api from '../module/api';

	// export
	export default {
		name: "homeSlider",
		data() {
			return {
				loading: true,
				sliders: [],
				listNews: [],
			};
		},
		methods: {
			// Goi slider o trang chu, goi sau khi call axios, gan data that
            callCarousel () {

				setTimeout(() => {
					// this.sliders = data;
					this.loading = false;

					this.$nextTick(() => {

						var $w_ = $(window).width();

						if( $w_ >= 768 ) {
							var slider_features = $(this.$el).find(".slider-features");

							$(slider_features).owlCarousel({
								loop: true,
								autoplay: false,
								autoplayTimeout: 3000,
								smartSpeed: 300,
								margin: 16,
								items: 3,
								autoWidth: false,
								dots: false,
								// nav: true,
								lazyLoad: true,
								responsiveClass: true,
								responsive:{
									// breakpoint from up
									320:{
										items: 1,
									},
									768:{
										items: 2,
									},
									1024:{
										items: 3,
									},
								}
							});

							// Go to the previous item
							$('.p_slider_features').click(function() {
								// With optional speed parameter
								// Parameters has to be in square bracket '[]'
								slider_features.trigger('prev.owl.carousel', [300]);
							})
							// Go to the next item
							$('.n_slider_features').click(function() {
								slider_features.trigger('next.owl.carousel');
							})
						}
					});
				}, 2000);
            },
			callbackNews(isSuccess, data, error) {
				if (isSuccess) {
					this.loading = false;
					
					if (data.data.length > 0) {
					this.listNews = data.data;
					this.callCarousel();
					// Update dữ liệu cache lại
					localStorage.setItem('FptplayNews', JSON.stringify(this.listNews));
					return;
					}
					return;
				}
				if (error) {
					this.isErrorApi = true;
				}
			},
  			checkPageHideHeader() {
				if (window.innerWidth <= 600) {
					return true;
				} else {
					return false
				}
        	},
			load() {
				// Đọc dữ liệu từ cache
				let cacheData = localStorage.getItem('FptplayNews');
				if (cacheData) {
					this.listNews = JSON.parse(cacheData);
					this.loading = false
				}

				// Gọi api để lấy dữ liệu mới
				api.getFeaturedNews(this.callbackNews);
			},

        },
		mounted() {
			var vm = this;
			this.callCarousel();
			this.load();
		},
	};
</script>
